module.exports = __webpack_public_path__ + "img/midi_monitor_setting.a477617a.png";